import { ListItemButton, ListItemIcon, Typography } from '@vapor/material'
import Apartment from '@mui/icons-material/Apartment'

type ListPropertyProps = {
  name: string
  isSelected: boolean
  onClick: () => void
}

export const ListProperty = (props: ListPropertyProps) => {
  const { name, isSelected, onClick } = props
  return (
    <ListItemButton //
      onClick={!isSelected ? onClick : undefined}
    >
      <ListItemIcon>
        <Apartment fontSize="small" />
      </ListItemIcon>
      <Typography variant={'body'} sx={{ fontWeight: isSelected ? '600' : undefined }}>
        {name}
      </Typography>
    </ListItemButton>
  )
}
